/**
 * The choose screen's own string, from the copy review (verifime-adr#683). The heading, group
 * titles and buttons are the shared EntityTypeSelector's, and the tiles carry their own copy.
 */

// COPY APPROVED (verifime-adr#683): Zoe McKeough, 2026-11-04
export const CHOOSE_ENTITY_INTRO =
  'Please select the type of entity you want to verify. If you do not have any entity types that apply to you, select individual to get started.';
